"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HeadingsStyle = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theming = require("../../../theming");

var _themeContants = require("../../../constants/themeContants");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Heading = function Heading(_ref) {
  var level = _ref.level,
      children = _ref.children,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["level", "children", "className"]);

  switch (level) {
    case "h1":
    case "H1":
    case "1":
    case 1:
      return _react["default"].createElement(HeadingH1, _extends({
        level: 1,
        className: className
      }, restProps), children);

    case "h2":
    case "H2":
    case "2":
    case 2:
      return _react["default"].createElement(HeadingH2, _extends({
        level: 2,
        className: className
      }, restProps), children);

    case "h3":
    case "H3":
    case "3":
    case 3:
      return _react["default"].createElement(HeadingH3, _extends({
        level: 3,
        className: className
      }, restProps), children);

    case "h4":
    case "H4":
    case "4":
    case 4:
      return _react["default"].createElement(HeadingH4, _extends({
        level: 4,
        className: className
      }, restProps), children);

    case "h5":
    case "H5":
    case "5":
    case 5:
      return _react["default"].createElement(HeadingH5, _extends({
        level: 5,
        className: className
      }, restProps), children);

    case "h6":
    case "H6":
    case "6":
    case 6:
      return _react["default"].createElement(HeadingH6, _extends({
        level: 6,
        className: className
      }, restProps), children);

    default:
      return _react["default"].createElement(HeadingH1, _extends({
        level: 1,
        className: className
      }, restProps), children);
    // 👈 we always have to return something
  }
};

Heading.themeProps = {
  heading: {
    name: "heading",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};
var HeadingsStyle = (0, _styledComponents.css)(["font-family:", ";", ";"], _theming.fontFamily.heading, (0, _theming.applyVariants)(Heading.themeProps.heading));
exports.HeadingsStyle = HeadingsStyle;

var HeadingH1 = _styledComponents["default"].h1.withConfig({
  displayName: "Heading__HeadingH1",
  componentId: "chhr1o-0"
})(["font-size:", ";", ";"], _theming.font.h1, HeadingsStyle);

var HeadingH2 = _styledComponents["default"].h2.withConfig({
  displayName: "Heading__HeadingH2",
  componentId: "chhr1o-1"
})(["font-size:", ";", ";"], _theming.font.h2, HeadingsStyle);

var HeadingH3 = _styledComponents["default"].h3.withConfig({
  displayName: "Heading__HeadingH3",
  componentId: "chhr1o-2"
})(["font-size:", ";", ";"], _theming.font.h3, HeadingsStyle);

var HeadingH4 = _styledComponents["default"].h4.withConfig({
  displayName: "Heading__HeadingH4",
  componentId: "chhr1o-3"
})(["font-size:", ";", ";"], _theming.font.h4, HeadingsStyle);

var HeadingH5 = _styledComponents["default"].h5.withConfig({
  displayName: "Heading__HeadingH5",
  componentId: "chhr1o-4"
})(["font-size:", ";", ";"], _theming.font.h5, HeadingsStyle);

var HeadingH6 = _styledComponents["default"].h6.withConfig({
  displayName: "Heading__HeadingH6",
  componentId: "chhr1o-5"
})(["font-size:", ";", ";"], _theming.font.h6, HeadingsStyle);

Heading.defaultProps = {
  level: "h1",
  className: null
};
Heading.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  level: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  className: _propTypes["default"].string
};
var _default = Heading;
exports["default"] = _default;